module.exports = __webpack_public_path__ + "media/images/customers_company_logos-8eed62f2.png";